module.exports = __webpack_public_path__ + "img/diagnosis-dialog-loading-back-icon.6067a887.png";